import { DeleteIcon, EditIcon } from '@/components/_common';
import {
  useWorkOrderChecklistFutureServiceList,
  useWorkOrderChecklistFutureServiceRemove,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { WorkOrderChecklistFutureService } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { useDisclosure } from '@/hooks';
import { Modal, Space, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useState } from 'react';
import { useWorkorderChecklistContext } from '../../WorkorderChecklistProvider';
import { WorkorderChecklistItemType } from '../../WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import ChecklistFutureServiceModalForm from '../FutureServiceModalForm';

const ChecklistFutureServiceList: React.FC = () => {
  const { checklistItemId, checklistItemType } = useWorkorderChecklistContext();
  const [futureService, setFutureService] =
    useState<WorkOrderChecklistFutureService>();
  const [modalOpened, modalAction] = useDisclosure(false, {
    onClose: () => setFutureService(undefined),
  });

  const futureServiceRemove = useWorkOrderChecklistFutureServiceRemove();

  const futureServiceList = useWorkOrderChecklistFutureServiceList({
    diagnosticId:
      checklistItemType == WorkorderChecklistItemType.Diagnostic
        ? checklistItemId
        : undefined,
    workOrderComplementId:
      checklistItemType == WorkorderChecklistItemType.Workorder
        ? checklistItemId
        : undefined,
  });

  function handleRemove(item: WorkOrderChecklistFutureService) {
    Modal.confirm({
      title: 'Remover serviço futuro',
      content: `Deseja remover o serviço futuro selecionado?`,
      okText: 'Remover',
      okType: 'danger',
      onOk: () => futureServiceRemove.mutateAsync(item.id),
    });
  }

  const columns: ColumnsType<WorkOrderChecklistFutureService> = [
    {
      dataIndex: 'date',
      title: 'Data',
      render: (date) => moment(date).format('DD/MM/YYYY'),
    },
    { dataIndex: 'description', title: 'Descrição' },
    {
      align: 'right',
      title: 'Ação',
      render: (_, item) => (
        <Space>
          <EditIcon
            iconProps={{
              onClick: () => {
                setFutureService(item);
                modalAction.open();
              },
            }}
          />
          <DeleteIcon onClick={() => handleRemove(item)} />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={futureServiceList.data}
        rowKey={(row) => row.id}
        pagination={false}
      />

      <ChecklistFutureServiceModalForm
        open={modalOpened}
        onCancel={modalAction.close}
        futureService={futureService}
      />
    </>
  );
};

export default ChecklistFutureServiceList;
